import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, StoreState } from "../../../store";
import { blogActions, blogSelectors } from '../../../ducks/blog';
import { appSelectors } from '../../../ducks/app';

export const useBlogDetail = (id: string) => {
  const dispatch = useDispatch<AppDispatch>();
  const [error, setError] = useState<string | null>(null);

  const loading = useSelector((state: StoreState) => appSelectors.isLoading(state));
  const blog = useSelector((state: StoreState) => blogSelectors.detail(state));

  const numericId = Number(id);

  useEffect(() => {
    setError(null);
    dispatch(blogActions.getBlogDetail.started({
      id: numericId,
      onError: () => setError('Failed to load blog detail')
    }));
  }, [dispatch, numericId]);

  return { blog, loading, error };
};